import React from 'react';
import NotesBlock from './NotesBlock';
import VulnerabilityIcon from 'assets/images/VulnerabilityIcon';
import { hasVeryHighVulnerability } from './utils';
import { EventCategory } from 'components/Analytics';
import { useScrollToElement } from 'common/hooks';
import { Region, MetroArea } from 'common/regions';

const VulnerabilityNote: React.FC<{
  ccviScore: number | null;
  region: Region;
}> = ({ ccviScore, region }) => {
  const veryHighVulnerability =
    ccviScore && hasVeryHighVulnerability(ccviScore);

  useScrollToElement();

  const title = 'Vulnerability is very high';
  const body = `${
    region instanceof MetroArea ? region.shortName : region.name
  } is more likely to experience severe physical and economic suffering from COVID, and to face harder, longer recovery.`;

  if (!veryHighVulnerability) {
    return null;
  }

  return (
    <NotesBlock
      icon={<VulnerabilityIcon />}
      title={title}
      to="#vulnerabilities"
      trackingCategory={EventCategory.VULNERABILITIES}
    >
      {body}
    </NotesBlock>
  );
};

export default VulnerabilityNote;
